import React, { useEffect, useState } from "react";
import { Nav } from "react-bootstrap";
import { useLocation } from 'react-router-dom'

const TablaMantenimientos = () => {
    const [showTable5KM, setShowTable5KM] = useState(true);
    const [tabSelected, setTabSelected] = useState("mantenimiento5000KM");
    const [tablaMantenimientos, setTablaMantenimientos] = useState([]);
    const location = useLocation();
    
    const obtenerIframe = (tabSelected) => {
        const urls = {
            mantenimiento5000KM: "https://app.powerbi.com/view?r=eyJrIjoiZmU0MzFhZTItMDVjNS00YTE0LWJjOTUtZjMyMjRjNmRhZWI4IiwidCI6IjkzYTMxMGEzLTQwMDItNDgzOS1iZTlmLTgwNGVlYTM2NjFiNiJ9",
            mantenimiento7500KM: "https://app.powerbi.com/view?r=eyJrIjoiNmI3ZWRiODItMzhiMy00MDQ0LTlhOTQtOTc4NTRlNThmNzMxIiwidCI6IjkzYTMxMGEzLTQwMDItNDgzOS1iZTlmLTgwNGVlYTM2NjFiNiJ9"
        };
        
        const url = tabSelected === "mantenimiento5000KM" ? urls.mantenimiento5000KM : urls.mantenimiento7500KM;

        return (
            <iframe
                title={`Mantenimientos ${tabSelected === "mantenimiento5000KM" ? "cada 5.000 km" : "cada 7.500 km"}`}
                width="100%"
                height="700px"
                src={url}
                allowFullScreen={true}
            />
        );
    };

    useEffect(() => {
        const iframe = obtenerIframe(tabSelected);
        setTablaMantenimientos(iframe);
    }, [location.search, tabSelected]);

    
    const handleSelect = (eventKey) => {
        setShowTable5KM(!showTable5KM);
        setTabSelected(eventKey);
    };


    return (
        <div>
            <Nav fill variant="tabs" onSelect={handleSelect}>
                <Nav.Item>
                    <Nav.Link className="tab-seleccionado" eventKey="mantenimiento5000KM" active={showTable5KM}>Mantenimientos
                        cada 5.000 km</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link className="tab-seleccionado" eventKey="mantenimiento7500KM" active={!showTable5KM}>Mantenimientos
                        cada 7.500
                        km</Nav.Link>
                </Nav.Item>
            </Nav>

            <div id="div1" className="mb-5">
                <table className="customers">
                    {tablaMantenimientos}
                </table>
            </div>
        </div>
    )
}

export default TablaMantenimientos
